// extracted by mini-css-extract-plugin
module.exports = {"header":"_3ygBO","title":"Xh-fn","text":"gzBH9"};